@if (id) {
  <a class="view-btn" (click)="downloadFile()">
    <i class="bi bi-file-arrow-down-fill"></i>
  </a>
}
